import React, { useState, useRef, useContext, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { clearMessage } from "../../../actions/message";
import { toast } from 'react-toastify';
import { Grid, IconButton, Button, InputLabel } from "@mui/material";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { CountryDropdown } from "react-country-region-selector";
import { DataGridPro, GridActionsCellItem, GridToolbarExport, GridToolbarContainer, GridColumnHeaderParams } from '@mui/x-data-grid-pro';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Avatar from '@mui/material/Avatar';
import Tab from '@mui/material/Tab';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { getCenters } from "../../../actions/center";
import SaveIcon from '@mui/icons-material/Save';
import { getExtras } from "../../../actions/extra";
import TabPanel from "../../../TabPanel";
import { height } from "@mui/system";
import * as dayjs from "dayjs";
import { getBookings, upsertBooking } from "../../../actions/booking";
import CircularProgress from '@mui/material/CircularProgress';

import CenterSelection from '../BookingDetails/CenterSelection';
import StudentDetails from '../BookingDetails/StudentDetails';
import ParentDetails from "../BookingDetails/ParentDetails";
import CourseDetails from '../BookingDetails/CourseDetails';
import HealthDetails from '../BookingDetails/HealthDetails';
import TransportDetails from "../BookingDetails/TransportDetails";
import PricingDetailsArray from "./PricingDetailsArray";
import PaymentsDetails from "./PaymentsDetails";
import FinishDetails from "./FinishDetails";
import LastChangesDetails from "./LastChangesDetails";
import StatusDetails from "./StatusDetails";
import { getBooking } from "../../../actions/booking";
import Backdrop from '@mui/material/Backdrop';

import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import DoneIcon from '@mui/icons-material/Done';
import DeleteIcon from '@mui/icons-material/Delete';
import DocumentsDetails from "./DocumentsDetails";
import { getUsers } from "../../../actions/user";
import Files from "./Files";
import { Info } from "@mui/icons-material";

const BookingsDetails = () => {

    const location = useLocation();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [booking, setBooking] = useState(null)

    const { user: currentUser } = useSelector((state) => state.auth);

    const { users: listUsers } = useSelector((state) => state.users);

    useEffect(() => {
        dispatch(getBooking(location.state, currentUser.id)).then((data) => {
            setBooking(data)
            initCurrentBooking(data);
        });

        dispatch(getUsers());

    }, []);


    const [value, setValue] = React.useState(0);

    const [loading, setLoading] = React.useState(false);
    const handleClose = () => {
        setLoading(false);
    };
    const handleToggle = () => {
        setLoading(!loading);
    };


    //Agent
    const [userID, setUserId] = useState(null);

    //_____STUDENT_____//
    const [firstName, setFirstName] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [email, setEmail] = useState(null);
    const [passport, setPassport] = useState(null);
    const [gender, setGender] = useState(null);
    const [nationality, setNationality] = useState(null);
    const [birthDate, setBirthDate] = useState(null);
    const [motherTongue, setMotherTongue] = useState(null);
    const [address, setAddress] = useState(null);
    const [address2, setAddress2] = useState(null);
    const [address3, setAddress3] = useState(null);
    const [country, setCountry] = useState(null);
    const [locality, setLocality] = useState(null);
    const [zip_code, setZipCode] = useState(null);
    const [phone, setPhone] = useState(null);
    const [countryName, setCountryName] = useState(null);

    const [profilePicture, setProfilePicture] = useState(null);
    const [passportPicture, setPassportPicture] = useState(null);

    //_____GUARDIAN_____//
    const [motherId, setMotherId] = useState(null);
    const [motherName, setMotherName] = useState(null);
    const [motherEmail, setMotherEmail] = useState(null);
    const [motherOccupation, setMotherOccupation] = useState(null);
    const [motherPhone, setMotherPhone] = useState(null);
    const [fatherId, setFatherId] = useState(null);
    const [fatherName, setFatherName] = useState(null);
    const [fatherEmail, setFatherEmail] = useState(null);
    const [fatherOccupation, setFatherOccupation] = useState(null);
    const [fatherPhone, setFatherPhone] = useState(null);
    const [unsupervisedFreeTime, setUnsupervisedFreeTime] = useState(null);

    //_____CENTER_____//
    const [ageGroup, setAgeGroup] = useState(null);
    const [extras, setExtras] = useState(null);
    const [weeks, setWeeks] = useState(null);
    const [status, setStatus] = useState(null);
    const [center, setCenter] = useState(null);
    const [payments, setPayments] = useState(null);

    //_____HEALTH____//
    const [asthmaOrBronchitis, setAsthmaOrBronchitis] = useState(null);
    const [fitsFaintingBlack, setFitsFaintingBlack] = useState(null);
    const [heartCondition, setHeartCondition] = useState(null);
    const [severeHeadaches, setSevereHeadaches] = useState(null);
    const [diabetes, setDiabetes] = useState(null);
    const [allergiesToKnownMedicines, setAllergiesToKnownMedicines] = useState(null);
    const [otherAllergies, setOtherAllergies] = useState(null);
    const [travelSickness, setTravelSickness] = useState(null);
    const [bedwettingIncontinence, setBedwettingIncontinence] = useState(null);
    const [anyMentalHealthProblems, setAnyMentalHealthProblems] = useState(null);
    const [regularMedication, setRegularMedication] = useState(null);
    const [regularHospitalTreatment, setRegularHospitalTreatment] = useState(null);
    const [anyMedicationPring, setAnyMedicationPring] = useState(null);
    const [anythingElse, setAnyThingElse] = useState(null);
    const [moreDetails, setMoreDetails] = useState(null);
    const [agreeNonPrescription, setAgreeNonPrescription] = useState(null);
    const [arrangeMedicalTreatment, setArrangeMedicalTreatment] = useState(null);
    const [roomingComment, setRoomingComment] = useState(null);

    //______TRANSPORT_____//
    const [departureAirport, setDepartureAirport] = useState(null);
    const [departureFlightNumber, setDepartureFlightNumber] = useState(null);
    const [departureUmService, setDepartureUmService] = useState(null);
    const [departureTransfer, setDepartureTransfer] = useState(null);
    const [departureHour, setDepartureHour] = useState(null);
    const [departureTerminal, setDepartureTerminal] = useState(null);
    const [arrivalAirport, setArrivalAirport] = useState(null);
    const [arrivalFlightNumber, setArrivalFlightNumber] = useState(null);
    const [arrivalUmService, setArrivalUmService] = useState(null);
    const [arrivalTransfer, setArrivalTransfer] = useState(null);
    const [arrivalHour, setArrivalHour] = useState(null);
    const [arrivalTerminal, setArrivalTerminal] = useState(null);
    const [arrivalDeparture, setArrivalDeparture] = useState(null);
    const [arrivalComment, setArrivalComment] = useState(null);
    const [departureComment, setDepartureComment] = useState(null);



    const [comment, setComment] = useState(null);
    const [total_discount, setTotalDiscount] = useState(null);
    const [total_journey, setTotalJourney] = useState(null);
    const [total_extra, setTotalExtra] = useState(null);
    const [total_extra_days, setTotalExtraDays] = useState(null);
    const [total_transport, setTotalTransport] = useState(null);
    const [total_um, setTotalUM] = useState(null);
    const [total, setTotal] = useState(null);
    const [total_commission, setTotalCommission] = useState(null);
    const [balance, setBalance] = useState(null);

    const [last_changes, setLastChanges] = useState(null);
    const [invoiceSent, setInvoiceSent] = useState(null);
    const [visaSent, setVisaSent] = useState(null);
    const [paymentConfirmationSent, setPaymentConfirmationSent] = useState(null);
    const [paymentDepositConfirmationSent, setPaymentDepositConfirmationSent] = useState(null);
    const [transferInfoSent, setTransferInfoSent] = useState(null);
    const [bookingConfirmationSent, setBookingConfirmationSent] = useState(null);
    const [creditNoteSent, setCreditNoteSent] = useState(null);
    const [certificateSent, setCertificateSent] = useState(null);

    const [files, setFiles] = useState(null);

    const [creditNoteNumber, setCreditNoteNumber] = useState(null)
    const [invoiceNumber, setInvoiceNumber] = useState(null)
    const [level, setLevel] = useState(null);

    const [isInitialLoading, setIsInitialLoading] = useState(true);

    const initCurrentBooking = (current_booking) => {


        setFiles(current_booking.files);
        setProfilePicture(current_booking.profilePicture);
        setPassportPicture(current_booking.passportPicture);

        setFirstName(current_booking.studentFirstName);
        setLastName(current_booking.studentLastName);
        setEmail(current_booking.studentEmail);
        setPassport(current_booking.studentIdCard);
        setGender(current_booking.studentGender);
        setNationality(current_booking.studentNationality);
        setBirthDate(dayjs(current_booking.studentBirthdate).format('YYYY-MM-DD'));
        setMotherTongue(current_booking.studentMotherTongue);
        setAddress(current_booking.studentAdress);
        setAddress2(current_booking.studentAdress2);
        setAddress3(current_booking.studentAdress3);
        setCountry(current_booking.studentCountry);
        setLocality(current_booking.studentLocality);
        setZipCode(current_booking.studentZipcode);
        setPhone(current_booking.studentPhone);
        setUserId(current_booking.idUser);

        if (current_booking.contacts.length > 0) {
            setMotherId(current_booking.contacts[0].id);
            setMotherName(current_booking.contacts[0].name);
            setMotherEmail(current_booking.contacts[0].email);
            setMotherOccupation(current_booking.contacts[0].occupation);
            setMotherPhone(current_booking.contacts[0].mobile);
            setFatherId(current_booking.contacts[1].id);
            setFatherName(current_booking.contacts[1].name);
            setFatherEmail(current_booking.contacts[1].email);
            setFatherOccupation(current_booking.contacts[1].occupation);
            setFatherPhone(current_booking.contacts[1].mobile);
            setUnsupervisedFreeTime(current_booking.freeTimeGuard);
        }


        //_____CENTER_____//
        setAgeGroup(current_booking.category);
        setExtras(current_booking.extras);
        setWeeks(current_booking.weeks);
        setStatus(current_booking.status);
        setCenter(current_booking.centerDTO);
        setPayments(current_booking.payments);

        //_____HEALTH____//
        setAsthmaOrBronchitis(current_booking.asthmaOrBronchitis);
        setFitsFaintingBlack(current_booking.fitsFaintingBlack);
        setHeartCondition(current_booking.heartCondition);
        setSevereHeadaches(current_booking.severeHeadaches);
        setDiabetes(current_booking.diabetes);
        setAllergiesToKnownMedicines(current_booking.allergiesToKnownMedicines);
        setOtherAllergies(current_booking.otherAllergies);
        setTravelSickness(current_booking.travelSickness);
        setBedwettingIncontinence(current_booking.bedwettingIncontinence);
        setAnyMentalHealthProblems(current_booking.anyMentalHealthProblems);
        setRegularMedication(current_booking.regularMedication);
        setRegularHospitalTreatment(current_booking.regularHospitalTreatment);
        setAnyMedicationPring(current_booking.anyMedicationPring);
        setAnyThingElse(current_booking.anythingElse);
        setMoreDetails(current_booking.medicalComment);
        setAgreeNonPrescription(current_booking.agreeNonPrescription);
        setArrangeMedicalTreatment(current_booking.arrangeMedicalTreatment);
        setRoomingComment(current_booking.roomingComment);

        //______TRANSPORT_____//
        setDepartureAirport(current_booking.idAirportDeparture);
        setDepartureFlightNumber(current_booking.departureFlightNumber);
        setDepartureUmService(current_booking.departureUm);
        setDepartureTransfer(current_booking.departureTransfert);
        setDepartureHour(current_booking.departureHour);
        setDepartureTerminal(current_booking.departureTerminal);
        setArrivalAirport(current_booking.idAirportArrival)
        setArrivalFlightNumber(current_booking.arrivalFlightNumber);
        setArrivalUmService(current_booking.arrivalUm);
        setArrivalTransfer(current_booking.arrivalTransfert);
        setArrivalTerminal(current_booking.arrivalTerminal);
        setArrivalDeparture([new Date(current_booking.arrivalHour), new Date(current_booking.departureHour)]);

        setArrivalComment(current_booking.arrivalComment)
        setDepartureComment(current_booking.departureComment)

        setArrivalHour(current_booking.arrivalHour.split('T')[1].split(':')[0] + ":" + current_booking.arrivalHour.split('T')[1].split(':')[1]);
        setDepartureHour(current_booking.departureHour.split('T')[1].split(':')[0] + ":" + current_booking.departureHour.split('T')[1].split(':')[1]);


        setComment(current_booking.finencialComment);
        setTotalDiscount(current_booking.totalDiscount ? current_booking.totalDiscount : 0);
        setTotalJourney(current_booking.totalJourney ? current_booking.totalJourney : 0);
        setTotalExtra(current_booking.totalExtra ? current_booking.totalExtra : 0);
        setTotalExtraDays(current_booking.totalExtraDays ? current_booking.totalExtraDays : 0);
        setTotalTransport(current_booking.totalTransport ? current_booking.totalTransport : 0);
        setTotalUM(current_booking.totalUm ? current_booking.totalUm : 0);
        setTotal(current_booking.total);
        setTotalCommission(current_booking.totalCommission);
        setBalance(current_booking.balance);
        setLastChanges(current_booking.lastChanges)

        setInvoiceSent(current_booking.invoiceSent)
        setVisaSent(current_booking.visaSent)
        setPaymentConfirmationSent(current_booking.paymentConfirmationSent)
        setPaymentDepositConfirmationSent(current_booking.paymentConfirmationDepositSent)
        setTransferInfoSent(current_booking.transferInfoSent)
        setBookingConfirmationSent(current_booking.bookingConfirmationSent)
        setCreditNoteSent(current_booking.creditNoteSent)
        setCertificateSent(current_booking.certificateSent)

        setLevel(current_booking.level)
        setInvoiceNumber(current_booking.invoiceNumber)
        setCreditNoteNumber(current_booking.creditNoteNumber)
    }

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };

    const save_booking = () => {

        setLoading(true)

        var tmp_booking = { id: booking.id }

        //Editing user
        tmp_booking.IdUserEditing = currentUser.id;

        //Center 
        tmp_booking.Center = { id: center.id }
        tmp_booking.IdCenter = center.id;

        tmp_booking.Category = ageGroup;
        tmp_booking.Extras = extras;
        tmp_booking.Weeks = weeks;
        //Student 
        tmp_booking.StudentFirstName = firstName;
        tmp_booking.StudentLastName = lastName
        tmp_booking.StudentEmail = email
        tmp_booking.StudentIdCard = passport
        tmp_booking.StudentGender = gender
        tmp_booking.StudentNationality = nationality;
        tmp_booking.StudentBirthdate = dayjs(birthDate).format('MM/DD/YYYY');
        tmp_booking.StudentMotherTongue = motherTongue;
        tmp_booking.StudentAdress = address;
        tmp_booking.StudentAdress2 = address2;
        tmp_booking.StudentAdress3 = address3;
        tmp_booking.StudentCountry = country;
        tmp_booking.StudentLocality = locality;
        tmp_booking.StudentZipcode = zip_code;
        tmp_booking.StudentPhone = phone;
        tmp_booking.StudentCountryName = countryName;

        //Agent
        tmp_booking.IdUser = userID;

        //Parents 
        tmp_booking.Contacts = [
            { id: motherId, Name: motherName, Email: motherEmail, Occupation: motherOccupation, Mobile: motherPhone, idBooking: booking.id },
            { id: fatherId, Name: fatherName, Email: fatherEmail, Occupation: fatherOccupation, Mobile: fatherPhone, idBooking: booking.id }
        ];
        tmp_booking.FreeTimeGuard = unsupervisedFreeTime == "1" ? true : false;

        //Health
        tmp_booking.AsthmaOrBronchitis = asthmaOrBronchitis == "1" ? true : false;
        tmp_booking.AllergiesToKnownMedicines = allergiesToKnownMedicines == "1" ? true : false;
        tmp_booking.FitsFaintingBlack = fitsFaintingBlack == "1" ? true : false;
        tmp_booking.OtherAllergies = otherAllergies == "1" ? true : false;
        tmp_booking.TravelSickness = travelSickness == "1" ? true : false;
        tmp_booking.HeartCondition = heartCondition == "1" ? true : false;
        tmp_booking.BedwettingIncontinence = bedwettingIncontinence == "1" ? true : false;
        tmp_booking.SevereHeadaches = severeHeadaches == "1" ? true : false;
        tmp_booking.AnyMentalHealthProblems = anyMentalHealthProblems == "1" ? true : false;
        tmp_booking.Diabetes = diabetes == "1" ? true : false;
        tmp_booking.RegularMedication = regularMedication == "1" ? true : false;
        tmp_booking.RegularHospitalTreatment = regularHospitalTreatment == "1" ? true : false;
        tmp_booking.AnyMedicationPring = anyMedicationPring == "1" ? true : false;
        tmp_booking.AgreeNonPrescription = agreeNonPrescription == "1" ? true : false;
        tmp_booking.ArrangeMedicalTreatment = arrangeMedicalTreatment == "1" ? true : false;
        tmp_booking.AnythingElse = anythingElse == "1" ? true : false;
        tmp_booking.MedicalComment = moreDetails;
        tmp_booking.roomingComment = roomingComment;
        tmp_booking.finencialComment = comment;

        //Transport
        tmp_booking.IdAirportDeparture = departureAirport;
        tmp_booking.IdAirportArrival = arrivalAirport;
        tmp_booking.DepartureFlightNumber = departureFlightNumber;
        tmp_booking.ArrivalFlightNumber = arrivalFlightNumber;
        tmp_booking.ArrivalUm = arrivalUmService == "1" ? true : false;
        tmp_booking.DepartureUm = departureUmService == "1" ? true : false;
        tmp_booking.DepartureTerminal = departureTerminal;
        tmp_booking.ArrivalTerminal = arrivalTerminal;
        tmp_booking.ArrivalTransfert = arrivalTransfer == "1" ? true : false;
        tmp_booking.DepartureTransfert = departureTransfer == "1" ? true : false;

        tmp_booking.ArrivalComment = arrivalComment;
        tmp_booking.DepartureComment = departureComment;


        let arrival_hour = arrivalHour ? arrivalHour.split(':')[0] : 0
        let arrival_minute = arrivalHour ? arrivalHour.split(':')[1] : 0

        let departure_hour = departureHour ? departureHour.split(':')[0] : 0
        let departure_minute = departureHour ? departureHour.split(':')[1] : 0

        tmp_booking.ArrivalHour = dayjs(arrivalDeparture[0]).set('hour', arrival_hour).set('minute', arrival_minute).format("MM/DD/YYYY HH:mm:ss")
        tmp_booking.DepartureHour = dayjs(arrivalDeparture[1]).set('hour', departure_hour).set('minute', departure_minute).format("MM/DD/YYYY HH:mm:ss")

        //Pricing
        tmp_booking.TotalDiscount = total_discount;
        tmp_booking.TotalUm = total_um;
        tmp_booking.TotalTransport = total_transport;
        tmp_booking.TotalJourney = total_journey
        tmp_booking.TotalExtra = total_extra;
        tmp_booking.TotalExtraDays = total_extra_days;
        tmp_booking.Total = total_journey + total_extra + total_um + total_transport + total_extra_days - total_discount - total_commission;
        tmp_booking.TotalBalance = balance;
        tmp_booking.TotalCommission = total_commission;

        tmp_booking.FinencialComment = comment;
        tmp_booking.Status = status;
        tmp_booking.DateTimeCreation = booking.datetimeCreation;

        tmp_booking.payments = payments.map((p) => {
            p.idBooking = booking.id;
            if (p.id.toString().length > 10) {
                p.id = Math.floor(-(Math.random() * (1000 - 1) + 1));
            }
            return p;
        });

        tmp_booking.files = files.map((f) => {
            f.idBooking = booking.id;
            if (f.id.toString().length > 10) {
                f.id = Math.floor(-(Math.random() * (1000 - 1) + 1));
            }
            return f;
        });

        tmp_booking.profilePicture = profilePicture;
        tmp_booking.passportPicture = passportPicture;

        tmp_booking.InvoiceSent = invoiceSent == "1" ? true : false;
        tmp_booking.VisaSent = visaSent == "1" ? true : false;
        tmp_booking.PaymentConfirmationSent = paymentConfirmationSent == "1" ? true : false;
        tmp_booking.PaymentConfirmationDepositSent = paymentDepositConfirmationSent == "1" ? true : false;
        tmp_booking.TransferInfoSent = transferInfoSent == "1" ? true : false;
        tmp_booking.BookingConfirmationSent = bookingConfirmationSent == "1" ? true : false;
        tmp_booking.CreditNoteSent = creditNoteSent == "1" ? true : false;
        tmp_booking.CertificateSent = certificateSent == "1" ? true : false;
        tmp_booking.Level = level;

        dispatch(upsertBooking(tmp_booking))
            .then(() => {
                setLoading(false)
                toast.success(
                    `Booking updated successfuly`, { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
                );
            })
            .catch((error) => {
                setLoading(false)
                toast.error(
                    `An Error occured while saving the booking. Please try again later.`,
                    { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
                );
            });
    }

    function a11yProps(index) { return { id: `vertical-tab-${index}`, 'aria-controls': `vertical-tabpanel-${index}` }; }

    function handleWeeksChange(weeks, newAgentID) {
        // Only recalculate prices if this is an actual change, not initial loading
        if (weeks && weeks.length !== 0) {
            recalculatePrices(weeks, newAgentID, ageGroup);
        }
        setWeeks(weeks);
    }

    function recalculatePrices(currentWeeks, newAgentID, currentAgeGroup) {
        if (center && currentWeeks) {
            let supplement = 0;
            setTotalCommission(0);

            if (currentWeeks.filter((w) => w.id === 5).length > 0) {
                supplement += 700;
            }

            let totalJourney = supplement;

            // Check if all training program prices are 0, null, or undefined
            const allPricesZeroOrNull = (!center.trainingProgramPrice1 || center.trainingProgramPrice1 === 0) &&
                                      (!center.trainingProgramPrice2 || center.trainingProgramPrice2 === 0) &&
                                      (!center.trainingProgramPrice3 || center.trainingProgramPrice3 === 0) &&
                                      (!center.trainingProgramPrice4 || center.trainingProgramPrice4 === 0);

            if (allPricesZeroOrNull && center.pricePerWeek > 0) {
                // Use center's default price if all program prices are 0 and center has a valid price
                totalJourney += currentWeeks.length * center.pricePerWeek;
            } else {
                // Use program-specific prices
                let pricePerWeek = 0;
                switch(currentAgeGroup) {
                    case 0:  // Little Explorers
                        pricePerWeek = center.trainingProgramPrice1 || center.pricePerWeek;
                        break;
                    case 1:  // New Adventurers
                        pricePerWeek = center.trainingProgramPrice2 || center.pricePerWeek;
                        break;
                    case 2:  // Rising Learners
                        pricePerWeek = center.trainingProgramPrice3 || center.pricePerWeek;
                        break;
                    case 3:  // Future Leaders
                        pricePerWeek = center.trainingProgramPrice4 || center.pricePerWeek;
                        break;
                    default:
                        pricePerWeek = center.pricePerWeek;
                        break;
                }
                totalJourney += currentWeeks.length * pricePerWeek;
            }

            setTotalJourney(totalJourney);

            let agent = listUsers.filter(u => u.id == newAgentID)[0];
            if (agent != null && agent.commissionType != 1) {
                if (agent.commissionType != 4) {
                    setTotalCommission(totalJourney * (agent.commissionPercentage / 100));
                } else {
                    setTotalJourney(currentWeeks.length * (agent.pricePerWeek));
                }
            } else {
                setTotalCommission(0);
            }
        }
    }

    useEffect(() => {
        if (weeks && center && !isInitialLoading) {
            // Only recalculate if this is not the initial loading
            recalculatePrices(weeks, userID, ageGroup);
        }
    }, [ageGroup]);

    // Add this to mark the end of initial loading
    useEffect(() => {
        if (booking && center) {
            setIsInitialLoading(false);
        }
    }, [booking, center]);

    function handleExtrasChange(extras) {
        const sum = extras.reduce((accumulator, object) => {
            return accumulator + object.price;
        }, 0);
        setTotalExtra(sum)
        setExtras(extras);
    }

    function calculateTotalUMPrice(a, d) {
        if (a == 1 && d == 1) {
            setTotalUM(center.umPrice * 2)
        } else if (a == 1 || d == 1) {
            setTotalUM(center.umPrice)
        } else {
            setTotalUM(0)
        }
    }

    function handleArrivalUmChange(arrival_um) {
        calculateTotalUMPrice(arrival_um, departureUmService);
        setArrivalUmService(arrival_um);
    }
    function handleDepartureUmChange(departure_um) {
        calculateTotalUMPrice(arrivalUmService, departure_um);
        setDepartureUmService(departure_um);
    }

    function calculateTotalTransportPrice(a, d) {
        if (a == 1 && d == 1) {
            setTotalTransport(center.transferPrice * 2)
        } else if (a == 1 || d == 1) {
            setTotalTransport(center.transferPrice)
        } else {
            setTotalTransport(0)
        }
    }

    function handleArrivalTransferChange(arrival_transfer) {
        calculateTotalTransportPrice(arrival_transfer, departureTransfer);
        setArrivalTransfer(arrival_transfer);
    }
    function handleDepartureTransferChange(departure_transfer) {
        calculateTotalTransportPrice(arrivalTransfer, departure_transfer);
        setDepartureTransfer(departure_transfer);
    }

    function handleArrivalDepartureChange(newWeeksArray, new_dates) {

        if (newWeeksArray.length > 0) {

            var initial_duration = dayjs(newWeeksArray[newWeeksArray.length - 1].endDate).diff(dayjs(newWeeksArray[0].startDate), 'day');
            var total_duration = dayjs(new_dates[1]).diff(dayjs(new_dates[0]), 'day');

            if (total_duration - initial_duration > 0) {
                setTotalExtraDays((total_duration - initial_duration) * center.priceExtraPerDay)
            } else {
                setTotalExtraDays(0)
            }
        }
        setArrivalDeparture(new_dates)
    }

    const getBookingTitle = () => {
        let studentName = `${booking.studentFirstName} ${booking.studentLastName}`
        let arrival = `${dayjs(booking.arrivalHour).format('DD/MM/YYYY')}`
        let departure = `${dayjs(booking.departureHour).format('DD/MM/YYYY')}`
        let centerName = center.name;

        return (
            <>
                <Chip label={centerName} m={2} color="primary" />
                <Chip label={arrival} m={2} variant="outlined" />
                <Chip label={departure} m={2} variant="outlined" />
            </>)
    }


    return (
        <div className="app-container">
            {booking && center ? <>

                <Box sx={{ flexGrow: 1 }}>
                    <Grid container>
                        <Grid item xs marginBottom={1}>
                            <Breadcrumbs className="breadcrumbsCustomStyle">
                                <IconButton size="large" color="inherit" onClick={() => navigate('/bookings-management')}>
                                    <ArrowBackIcon />
                                </IconButton>
                                {getBookingTitle()}
                            </Breadcrumbs>
                        </Grid>
                    </Grid>
                </Box>

                <Grid container spacing={1}>
                    <Grid item xs={9} sx={{ borderTop: 3, borderColor: 'primary.main' }}>
                        <Box sx={{ bgcolor: 'background.paper', minHeight: '650px', border: 5, borderColor: 'primary.main_very_light' }} >
                            <Grid container>
                                <Grid item xs={10}>
                                    {currentUser.type == 1 ?
                                        <Tabs
                                            centered
                                            value={value}
                                            onChange={handleTabChange}
                                            sx={{ borderRight: 2, borderColor: 'divider' }} >
                                            <Tab label="Student" {...a11yProps(0)} />
                                            <Tab label="Course" {...a11yProps(1)} />
                                            <Tab label="Guardian" {...a11yProps(2)} />
                                            <Tab label="Health" {...a11yProps(3)} />
                                            <Tab label="Transport" {...a11yProps(4)} />
                                            <Tab label="Payments" {...a11yProps(5)} />
                                            <Tab label="Last Changes" {...a11yProps(6)} />
                                            <Tab label="Signature" {...a11yProps(7)} />
                                            <Tab label="Documents" {...a11yProps(8)} />
                                            <Tab label="Files" {...a11yProps(9)} />
                                        </Tabs> :
                                        <Tabs
                                            centered
                                            value={value}
                                            onChange={handleTabChange}
                                            sx={{ borderRight: 2, borderColor: 'divider' }} >
                                            <Tab label="Student" {...a11yProps(0)} />
                                            <Tab label="Course" {...a11yProps(1)} />
                                            <Tab label="Guardian" {...a11yProps(2)} />
                                            <Tab label="Health" {...a11yProps(3)} />
                                            <Tab label="Transport" {...a11yProps(4)} />
                                            <Tab style={{ display: 'none' }} />
                                            <Tab style={{ display: 'none' }} />
                                            <Tab style={{ display: 'none' }} />
                                            <Tab style={{ display: 'none' }} />
                                            <Tab label="Files" {...a11yProps(9)} />
                                        </Tabs>}
                                </Grid>
                                <Grid item xs={2} justifyContent={"center"} display={"flex"} margin={"auto"}>
                                    {currentUser && currentUser.type != 2 ?
                                        <StatusDetails status={status} setStatus={setStatus} /> :
                                        <></>
                                    }
                                </Grid>
                            </Grid>


                            <TabPanel value={value} index={0}>
                                <Box sx={{ paddingLeft: 2, paddingRight: 2, paddingBottom: 2 }}>
                                    <StudentDetails
                                        setFirstName={setFirstName} firstNameValue={firstName}
                                        setLastName={setLastName} lastNameValue={lastName}
                                        setGender={setGender} genderValue={gender}
                                        setNationality={setNationality} nationalityValue={nationality}
                                        setAddress={setAddress} addressValue={address}
                                        setAddress2={setAddress2} address2Value={address2}
                                        setCountry={setCountry} countryValue={country}
                                        setLocality={setLocality} localityValue={locality}
                                        setBirthDate={setBirthDate} birthDateValue={birthDate}
                                        setMotherTongue={setMotherTongue} motherTongueValue={motherTongue}
                                        setPhone={setPhone} phone={phone}
                                        setEmail={setEmail} emailValue={email}
                                        setPassport={setPassport} passportValue={passport}
                                        setAddress3={setAddress3} address3Value={address3}
                                        setZipCode={setZipCode} zipCodeValue={zip_code}
                                        setAgeGroup={setAgeGroup} ageGroup={ageGroup}
                                        hideTitle={true}

                                        setProfilePicture={setProfilePicture} profilePicture={profilePicture}
                                        setPassportPicture={setPassportPicture} passportPicture={passportPicture}
                                        readonly={currentUser.type == 2}
                                        center={center}
                                        level={level} setLevel={setLevel}
                                        userType={currentUser.type}
                                        setCountryName={setCountryName} />
                                </Box>
                            </TabPanel>

                            <TabPanel value={value} index={1}>
                                <Box sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                    <CourseDetails
                                        setAgeGroup={setAgeGroup}
                                        ageGroup={ageGroup}
                                        arrivalDeparture={arrivalDeparture}
                                        setArrivalDeparture={handleArrivalDepartureChange}
                                        extras={extras}
                                        setExtras={handleExtrasChange}
                                        selectedCenterValue={center}
                                        setWeeks={handleWeeksChange}
                                        weeks={weeks}
                                        is_edition_mode={true}
                                        readonly={currentUser.type == 2}
                                        is_admin={currentUser.type == 1}
                                        center={center}
                                        birthDate={birthDate}
                                    />
                                </Box>
                            </TabPanel>
                            <TabPanel value={value} index={2}>
                                <Box sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                    <ParentDetails
                                        setMotherName={setMotherName} motherNameValue={motherName}
                                        setMotherEmail={setMotherEmail} motherEmailValue={motherEmail}
                                        setMotherOccupation={setMotherOccupation} motherOccupationValue={motherOccupation}
                                        setFatherName={setFatherName} fatherNameValue={fatherName}
                                        setFatherEmail={setFatherEmail} fatherEmailValue={fatherEmail}
                                        setFatherOccupation={setFatherOccupation} fatherOccupationValue={fatherOccupation}
                                        setMotherPhone={setMotherPhone} motherPhone={motherPhone}
                                        setFatherPhone={setFatherPhone} fatherPhone={fatherPhone}
                                        setUnsupervisedFreeTime={setUnsupervisedFreeTime} unsupervisedFreeTime={unsupervisedFreeTime}
                                        hideTitle={true} editVersion={true} readonly={currentUser.type == 2} />
                                </Box>
                            </TabPanel>
                            <TabPanel value={value} index={3}>
                                <Box sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                    <HealthDetails
                                        setAsthmaOrBronchitis={setAsthmaOrBronchitis} asthmaOrBronchitisValue={asthmaOrBronchitis}
                                        setFitsFaintingBlack={setFitsFaintingBlack} fitsFaintingBlackValue={fitsFaintingBlack}
                                        setHeartCondition={setHeartCondition} heartConditionValue={heartCondition}
                                        setSevereHeadaches={setSevereHeadaches} severeHeadachesValue={severeHeadaches}
                                        setDiabetes={setDiabetes} diabetesValue={diabetes}
                                        setAllergiesToKnownMedicines={setAllergiesToKnownMedicines} allergiesToKnownMedicinesValue={allergiesToKnownMedicines}
                                        setOtherAllergies={setOtherAllergies} otherAllergiesValue={otherAllergies}
                                        setTravelSickness={setTravelSickness} travelSicknessValue={travelSickness}
                                        setBedwettingIncontinence={setBedwettingIncontinence} bedwettingIncontinenceValue={bedwettingIncontinence}
                                        setAnyMentalHealthProblems={setAnyMentalHealthProblems} anyMentalHealthProblemsValue={anyMentalHealthProblems}
                                        setRegularMedication={setRegularMedication} regularMedicationValue={regularMedication}
                                        setRegularHospitalTreatment={setRegularHospitalTreatment} regularHospitalTreatmentValue={regularHospitalTreatment}
                                        setAnyMedicationPring={setAnyMedicationPring} anyMedicationPringValue={anyMedicationPring}
                                        setAnyThingElse={setAnyThingElse} anythingElseValue={anythingElse}
                                        setMoreDetails={setMoreDetails} moreDetailsValue={moreDetails}
                                        setAgreeNonPrescription={setAgreeNonPrescription} agreeNonPrescriptionValue={agreeNonPrescription}
                                        setArrangeMedicalTreatment={setArrangeMedicalTreatment} arrangeMedicalTreatmentValue={arrangeMedicalTreatment}
                                        roomingComment={roomingComment} setRoomingComment={setRoomingComment}
                                        hideTitle={true} editVersion={true} readonly={currentUser.type == 2} />
                                </Box>
                            </TabPanel>
                            <TabPanel value={value} index={4}>
                                <Box sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                    <TransportDetails
                                        selectedCenter={center}
                                        arrivalAirport={arrivalAirport} setArrivalAirport={setArrivalAirport}
                                        departureAirport={departureAirport} setDepartureAirport={setDepartureAirport}

                                        arrivalFlightNumber={arrivalFlightNumber} setArrivalFlightNumber={setArrivalFlightNumber}
                                        departureFlightNumber={departureFlightNumber} setDepartureFlightNumber={setDepartureFlightNumber}

                                        arrivalHour={arrivalHour} setArrivalHour={setArrivalHour}
                                        departureHour={departureHour} setDepartureHour={setDepartureHour}

                                        arrivalTerminal={arrivalTerminal} setArrivalTerminal={setArrivalTerminal}
                                        departureTerminal={departureTerminal} setDepartureTerminal={setDepartureTerminal}

                                        arrivalUmService={arrivalUmService} setArrivalUmService={handleArrivalUmChange}
                                        departureUmService={departureUmService} setDepartureUmService={handleDepartureUmChange}

                                        arrivalTransfer={arrivalTransfer} setArrivalTransfer={handleArrivalTransferChange}
                                        departureTansfer={departureTransfer} setDepartureTransfer={handleDepartureTransferChange}

                                        arrivalComment={arrivalComment} setArrivalComment={setArrivalComment}
                                        departureComment={departureComment} setDepartureComment={setDepartureComment}

                                        hideTitle={true} editVersion={true}
                                        umPrice={center.umPrice}
                                        readonly={currentUser.type == 2}
                                    />
                                </Box>
                            </TabPanel>
                            <TabPanel value={value} index={5} >
                                <Box sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                    <PaymentsDetails payments={payments} setPayments={setPayments} booking_id={booking.id} comment={comment} setComment={setComment} />
                                </Box>
                            </TabPanel>
                            <TabPanel value={value} index={6}>
                                <LastChangesDetails setCurrentStatus={setStatus} last_changes={last_changes} />
                            </TabPanel>
                            <TabPanel value={value} index={7}>
                                <FinishDetails edit_mode={true} comment={comment} setComment={setComment} current_booking_id={booking.id} />
                            </TabPanel>
                            <TabPanel value={value} index={8}>
                                <DocumentsDetails
                                    booking_id={booking.id}
                                    invoiceSent={invoiceSent} setInvoiceSent={setInvoiceSent}
                                    visaSent={visaSent} setVisaSent={setVisaSent}
                                    paymentConfirmationSent={paymentConfirmationSent} setPaymentConfirmationSent={setPaymentConfirmationSent}
                                    paymentDepositConfirmationSent={paymentDepositConfirmationSent} setPaymentDepositConfirmationSent={setPaymentDepositConfirmationSent}
                                    transferInfoSent={transferInfoSent} setTransferInfoSent={setTransferInfoSent}
                                    bookingConfirmationSent={bookingConfirmationSent} setBookingConfirmationSent={setBookingConfirmationSent}
                                    userID={userID} setUserId={setUserId} listUsers={listUsers}
                                    creditNoteSent={creditNoteSent} setCreditNoteSent={setCreditNoteSent}
                                    studentFirstName={firstName} studentLastName={lastName}
                                    invoiceNumber={invoiceNumber}
                                    creditNoteNumber={creditNoteNumber}
                                    handleWeeksChange={handleWeeksChange} weeks={weeks}
                                    certificateSent={certificateSent} setCertificateSent={setCertificateSent}

                                />
                            </TabPanel>
                            <TabPanel value={value} index={9} >
                                <Box sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                    <Files files={files} setFiles={setFiles} booking_id={booking.id} profilePicture={profilePicture} passportPicture={passportPicture} student={{ name: firstName, lastname: lastName }} />
                                </Box>
                            </TabPanel>
                        </Box>
                    </Grid>

                    {(currentUser.type == 1 || currentUser.type == 3 || currentUser.type == 4) &&
                        <Grid item xs={3} md={3} className="">
                            <Grid container>
                                <Grid item xs={12}>
                                    <PricingDetailsArray
                                        center={center}
                                        total_discount={total_discount} setTotalDiscount={setTotalDiscount}
                                        total_um={total_um} setTotalUM={setTotalUM}
                                        total_journey={total_journey} setTotalJourney={setTotalJourney}
                                        total_extra={total_extra} setTotalExtra={setTotalExtra}
                                        total_extra_days={total_extra_days} setTotalExtraDays={setTotalExtraDays}
                                        total_transport={total_transport} setTotalTransport={setTotalTransport}
                                        total={total} setTotal={setTotal}
                                        total_commission={total_commission} setTotalCommission={setTotalCommission}
                                        balance={balance} setBalance={setBalance}
                                        edit_mode={currentUser.type == 1}

                                        payments={payments}
                                    />
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Box sx={{ width: '100%', backgroundColor: "#FFFFFF", padding: 3, borderColor: 'primary.main' }}>
                                    <Button sx={{ width: '100%' }} variant="contained" onClick={() => { save_booking() }} endIcon={<SaveIcon />}>Save changes</Button>
                                </Box>
                            </Grid>
                        </Grid>}
                </Grid>
            </> : <>
                <Grid container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ width: '100%' }}>
                    <Grid item sx={{ width: '100%' }}>
                        <Breadcrumbs aria-label="breadcrumb" >
                            <IconButton size="large" color="inherit" onClick={() => navigate('/bookings-management')}>
                                <ArrowBackIcon />
                            </IconButton>
                            <Typography fontSize={23} color="text.primary" fontWeight={"bold"}></Typography>
                        </Breadcrumbs>
                        <Grid container spacing={1} sx={{ width: '100%' }}>
                            <Grid item xs={currentUser.type == 1 ? 9 : 12} md={currentUser.type == 1 ? 9 : 12} sx={{ borderTop: 3, borderColor: 'primary.main', width: '100%' }}>
                                <Box sx={{ bgcolor: 'background.paper', minHeight: '650px', width: '100%', border: 5, borderColor: 'primary.main_very_light' }} >
                                    <Grid container justifyContent={'center'} alignContent={"center"} alignItems={"center"}>
                                        <CircularProgress />
                                    </Grid>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </>}
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
                onClick={handleClose}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div >
    )
}

export default BookingsDetails